import React from 'react';

import './Loading.css';

const Loading = () => <span className="Loading"></span>

export default Loading;